import React from 'react';
import clsx from 'clsx';
import useStyles from './style';

export interface OutlinedAddonProps {
    /**
     * The content of the component, normally an `IconButton` or string.
     */
    children?: React.ReactNode;
    /**
     * The position this adornment should appear relative to the `Input`.
     */
    position?: 'start' | 'end';
    /**
     * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
     */
    margin?: 'dense' | 'normal';
    /**
     * The variant addon (on the start/end side of) the input field.
     */
    variant?: 'search' | 'number' | 'text';
    /**
     * Disable pointer events on the root.
     * This allows for the content of the adornment to focus the input on click.
     */
    disablePointerEvents?: boolean;
    /**
     * If `true`, disables gutter padding.
     */
    disableGutters?: boolean;
}

const OutlinedAddon: React.FC<OutlinedAddonProps> = ({
    children,
    position,
    margin,
    variant = 'text',
    disablePointerEvents = false,
    disableGutters = false,
}: OutlinedAddonProps) => {
    const classes = useStyles();
    const className = clsx(classes.root, {
        [classes.positionStart]: position === 'start',
        [classes.positionEnd]: position === 'end',
        [classes.marginDense]: margin === 'dense',
        [classes.variantSearch]: variant === 'search',
        [classes.variantNumber]: variant === 'number',
        [classes.variantText]: variant === 'text',
        [classes.disablePointerEvents]: disablePointerEvents,
        [classes.gutters]: variant !== 'search' && !disableGutters,
    });

    return <div className={className}>{children}</div>;
};

export default OutlinedAddon;
